module.exports = __webpack_public_path__ + "img/pesos.1f2ab6c8.png";